define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var TodoModel = /** @class */ (function () {
        function TodoModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.Task = ko.observable();
            this.EndDate = ko.observable();
            this.IsDone = ko.observable(false);
            this.StatusId = ko.observable();
            this.PriorityId = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, TodoModel.Mapping, self);
            }
        }
        TodoModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new TodoModel(options.data);
            }
        };
        return TodoModel;
    }());
    return TodoModel;
});
//# sourceMappingURL=TodoModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/TodoModel.js
// module id = 203
// module chunks = 2